import {Radar, mixins} from 'vue-chartjs';

export default Radar.extend({
    mixins: [mixins.reactiveProp],
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
        labels: {
            type: Array,
            default: () => {
                return [];
            },
        },
        legend: {
            default: () => {
                return true;
            },
        },
        backgroundFill: {
            default: () => {
                return true;
            },
        },
        options: {
            type: Object,
            default: () => {
                return {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true
                    }
                }
            }
        },
        colors: {
            type: Array,
            default: () => {
                return ["#28a745", "#007bff", "#ffc107", "#dc3545"];
            },
        },
        chartData: {},

    },
    data() {
        return {}
    },

    mounted() {
        this.render();
    },
    methods: {
        render: function () {
            this.setColor();
            this.setBackgroundFill(this.backgroundFill);
            this.renderChart({labels: this.labels, datasets: this.items}, this.options);
        },
        setColor: function () {
            this.items.forEach((value, index) => {
                let color;

                if ('color' in value) {
                    color = value.color;
                } else if (index in this.colors) {
                    color = this.colors[index];
                }

                value.backgroundColor = this.hexToRgbA(color, 0.5);
                value.borderColor = color;
                value.pointBackgroundColor = color;
                value.pointHoverBorderColor = color;
            });
        },
        setBackgroundFill: function (backgroundFill) {

            this.items.forEach((value) => {
                value.fill = backgroundFill;
            });
        },
        hexToRgbA: function (hex, transparency = 1) {
            let c;
            if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
                c = hex.substring(1).split('');
                if (c.length === 3) {
                    c = [c[0], c[0], c[1], c[1], c[2], c[2]];
                }
                c = '0x' + c.join('');
                return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + transparency + ')';
            }
            throw new Error('Bad Hex');
        }
    },
    watch: {
        labels: {
            handler: function (newData, oldData) {
                this._chart.data.labels = newData;
                this._chart.update();
            },
        },
        items: {
            handler: function (newData, oldData) {
                this._chart.data.datasets = newData;
                this.setColor();
                this._chart.update();
            }
        },
        legend: {
            handler: function (newData, oldData) {
                this._chart.options.legend.display = newData;
                this._chart.update();
            }
        },
        backgroundFill: {
            handler: function (newData, oldData) {
                this.setBackgroundFill(newData);
                this._chart.update();
            }
        }
    },
})


// WEBPACK FOOTER //
// ./src/components/RadarChart.js